import React from 'react';
import { Avatar, Drawer } from 'antd';
import { useMediaQuery } from '@mui/material';
import { theme } from '../../../../components/theme/theme';
import { CloseIcon } from '../../../../components/icons';
import { getBank } from 'banks-ng';
import { formatDate, formatNumber } from '../../../../utils/helper';
import { TreasuryTransaction } from '../../../../interfaces/Treasury';

const TreasuryTransactionDetails = ({
    open,
    onClose,
    details
}: {
    open: boolean;
    onClose: () => void;
    details: TreasuryTransaction;
}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Drawer
            placement={isMobile ? 'bottom' : 'right'}
            closable={false}
            onClose={() => onClose()}
            open={open}
            width={420}
            height={'75vh'}
            className='!bg-white !rounded-t-xl pt-6 lg:pt-0 lg:!rounded-t-none'
        >
            <div className='px-4 pt-10  lg:w-[400px] mx-auto pb-4 max-w-[400px] w-full '>
                <div className='justify-between flex items-center'>
                    <h2 className='mb-2 text-[18px] font-semibold text-ebony'>
                        Transaction Details
                    </h2>

                    <div className='cursor-pointer' onClick={onClose}>
                        <CloseIcon />
                    </div>
                </div>
                <div className='w-full divide-y-2 divide-gray300 space-y-4'>
                    <div className='space-y-1 mt-6'>
                        {details?.bankId && (
                            <div className='flex gap-3 items-center'>
                                <Avatar
                                    size='default'
                                    src={getBank(details?.bankId)?.logo}
                                    style={{
                                        border: '1px solid #D0D5DD',
                                        background: 'transparent'
                                    }}
                                />
                                <p className='text-paleSky text-base font-medium'>
                                    {getBank(details?.bankId)?.name}
                                </p>
                            </div>
                        )}
                        <p className='text-paleSky text-sm font-medium'>
                            <span className='font-light'>Acct No: </span>
                            {details?.accountNumber || 'N/A'}
                        </p>
                        <p className='text-paleSky text-sm font-medium'>
                            <span className='font-light'>Acct Name: </span>
                            {details?.accountName || 'N/A'}
                        </p>
                    </div>

                    <div className='space-y-1 pt-6'>
                        <p className='text-steelBlue text-base'>
                            Transaction type
                        </p>
                        <p className='text-paleSky text-sm font-light capitalize'>
                            {details?.type}
                        </p>
                    </div>

                    <div className='space-y-1 pt-6'>
                        <p className='text-steelBlue text-base '>
                            Balance before transaction
                        </p>
                        <p className='text-paleSky text-sm font-light capitalize'>
                            NGN {formatNumber(parseFloat(details?.balance))}
                        </p>
                    </div>
                    <div className='space-y-1 pt-6'>
                        <p className='text-steelBlue text-base '>
                            Balance after transaction
                        </p>
                        <p className='text-paleSky text-sm font-light capitalize'>
                            NGN {formatNumber(parseFloat(details?.balance))}
                        </p>
                    </div>

                    <div className='space-y-1 pt-6'>
                        <p className='text-steelBlue text-base '>Narration</p>
                        <p className='text-paleSky text-sm font-light capitalize'>
                            {details?.narration}
                        </p>
                    </div>

                    <div className='space-y-1 pt-6'>
                        <p className='text-steelBlue text-base '>Date</p>
                        <p className='text-paleSky text-sm font-medium capitalize'>
                            {formatDate(details?.createdAt)}
                        </p>
                    </div>

                    <div className='space-y-1 pt-6'>
                        <p className='text-steelBlue text-base'>Status</p>
                        <p className='text-sm font-medium capitalize py-1 px-3 text-[#027A48] bg-[#ECFDF3] rounded-xl w-max'>
                            {details?.status ?? 'Successful'}
                        </p>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default TreasuryTransactionDetails;
